import { DashboardInformation, DimensionTypes, DimensionValueGroup, MetricTypes } from '../entities/Dashboard';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { KpiFactory } from './KpiFactory';

/**
 * ダッシュボード情報を作成するファクトリークラス
 */
export class DashboardInformationFactory {
  /**
   * DashboardInformationを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<DashboardInformation> = {}): DashboardInformation => {
    const dashboardInformation: DashboardInformation = {
      metricType: initialData.metricType ?? MetricTypes.UNKNOWN,
      dimensionType: initialData.dimensionType ?? DimensionTypes.UNKNOWN,
      dimensionValueGroups:
        initialData.dimensionValueGroups?.map(
          (dimensionValueGroup): DimensionValueGroup => ({
            dimensionValues: dimensionValueGroup.dimensionValues,
            kpi: dimensionValueGroup.kpi.map((k) => KpiFactory.create(k)),
            businesses: dimensionValueGroup.businesses?.map((b) => BusinessFactory.create(b)) ?? [],
            amounts: dimensionValueGroup.amounts,
          })
        ) ?? [],
    };
    return dashboardInformation;
  };
}
